exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NoActivity-module__no-activity___SaYuU{height:100%;max-height:340px;width:250px;padding:1rem;background-color:#ececec;border:10px solid #fff;border-radius:17px;box-shadow:0 0 10px rgba(0,0,0,.05);display:flex;align-items:center;justify-content:center;flex-direction:column;gap:.5rem}.NoActivity-module__no-activity___SaYuU p{text-align:center}.NoActivity-module__no-activity___SaYuU .NoActivity-module__description___100UV{color:#b4bac3;font-size:14px}", ""]);

// exports
exports.locals = {
	"no-activity": "NoActivity-module__no-activity___SaYuU",
	"description": "NoActivity-module__description___100UV"
};